import React from 'react';
import './AccountSecurity.scss';

export default function AccountSecurity () {
    return (
        <div className='account-security'>
            Account Security!
        </div>
    );
};